<template>
  <div>
    <render-product
      v-if="isHasBuyProduct"
      @onRenew="handleRenew"
      @onAppend="handleAppend"
      @onActivate="handleActivate"
      @onAuth="handleAuth"
      @onUpgrade="handleUpgrade"
      @onAireachActivate="handleAireachActivate"
    />
    <render-empty
      v-else
      @onBuy="handleBuy"
    />

    <activate-modal
      :visible.sync="showActiveModal"
      :loading="isRequesting"
      @submit="handleActivateSubmit"
      @close="showActiveModal = false"
    />

    <ai-reach-activate-modal
      :visible.sync="showAireachActivateModal"
      :ai-reach-links="aiReachLinks"
      @close="showAireachActivateModal = false"
      @submit-success="handleAireachActivateSuccess"
    />

    <special-edition-tip-modal
      :visible.sync="showSpecialEditionTipModal"
      @close="showSpecialEditionTipModal = false"
      @confirm="handleSpecialEditionConfirm"
    />
  </div>
</template>
<script>
  import {mapActions, mapState} from 'vuex'
  import { ORDER_TYPE_RENEW, ORDER_TYPE_APPEND } from '@utils/constants'
  import OrderApi from '@api/order'
  import RenderProduct from './RenderProduct'
  import RenderEmpty from './RenderEmpty'
  import ActivateModal from './ActivateModal'
  import AiReachActivateModal from './AiReachActivateModal'
  import SpecialEditionTipModal from './SpecialEditionTipModal'

  export default {
    data () {
      return {
        isRequesting: false,
        showWeChatModal: false,
        showActiveModal: false,
        showAireachActivateModal: false,
        showSpecialEditionTipModal: false,
        aiReachLinks: {},
        pendingActivateOrderId: null,
        pendingActivateOrderProductId: null,
      }
    },
    computed: {
      ...mapState('home', {
        productList: state => state.productList
      }),
      isHasBuyProduct () {
        return this.productList.length > 0
      }
    },
    methods: {
      ...mapActions('home', ['fetchProductInfo']),
      handleBuy () {
        this.$router.push('/store')
      },
      handleRenew () {
        this.$router.push(`/store/${ORDER_TYPE_RENEW}`)
      },
      handleAppend () {
        this.$router.push(`/store/${ORDER_TYPE_APPEND}`)
      },
      async handleActivate (orderId, orderProductId, isCrmProduct) {
        if (this.isRequesting) return
        if (Number(isCrmProduct) === 1) {
          this.showWeChatModal = true
          return;
        }

        // 检查是否为特供版，需要展示打包激活须知弹窗
        const product = this.productList.find(item => item.order_id === orderId)
        if (product && product.is_special_edition) {
          this.pendingActivateOrderId = orderId
          this.pendingActivateOrderProductId = orderProductId
          this.showSpecialEditionTipModal = true
          return
        }

        await this.doActivate(orderId, orderProductId)
      },
      async doActivate(orderId, orderProductId) {
        this.isRequesting = true
        await OrderApi.editOrderActivate({
          order_id: orderId, order_product_id: orderProductId,
        })
        await this.fetchProductInfo()
        this.isRequesting = false
        this.showActiveModal = false
        this.$message.success(this.$t('order.activateSuccess'))
      },
      async handleSpecialEditionConfirm() {
        this.showSpecialEditionTipModal = false
        await this.doActivate(this.pendingActivateOrderId, this.pendingActivateOrderProductId)
        this.pendingActivateOrderId = null
        this.pendingActivateOrderProductId = null
      },
      handleUpgrade (orderId, orderProductId) {
        this.orderId = orderId
        this.orderProductId = orderProductId
        this.showActiveModal = true
      },
      handleAuth () {
        this.$router.push('/order/auth')
      },
      async handleActivateSubmit({ businessId, activationType }) {
        if(activationType !== 'upgrade') {
          this.handleActivate(this.orderId, this.orderProductId, false)
          return;
        }

        this.isRequesting = true

        const params = {
          order_id: this.orderId,
          order_product_id: this.orderProductId,
          business_id: businessId,
        }

        try {
          await OrderApi.shopUpgrade(params)
          await this.fetchProductInfo()
          this.$message.success(this.$t('order.activateSuccess'))
        } catch (err) {
          // this.$message.error('提交失败')
        } finally {
          this.isRequesting = false
          this.showActiveModal = false
        }
      },
      handleAireachActivate(orderId) {
        this.aiReachLinks = this.productList.find(item => item.order_id === orderId).ai_reach_links || {};
        this.showAireachActivateModal = true
      },
      handleAireachActivateSuccess() {
        this.$message.success('提交成功，请查看具体可激活时间')
        this.fetchProductInfo()
      }
    },
    components: {
      RenderProduct,
      RenderEmpty,
      ActivateModal,
      AiReachActivateModal,
      SpecialEditionTipModal
    }
  }
</script>

